import NotificationService from '../../services/NotificationService'

const state = () => ({
    pages: 0,
    page: 1,
    notificationLoading: false,
    notifications: localStorage.getItem('notifications') ? JSON.parse(localStorage.getItem('notifications')) : [],
    totalPendente: null
})
  
const mutations = {
    SET_NOTIFICATIONS: (state, payload) => {
        state.notifications = payload.notifications;
        state.pages = payload.pages;
        state.page = payload.pageNumber;
        localStorage.setItem('notifications', JSON.stringify(payload.notifications));
    },
    SET_MORE_NOTIFICATIONS: (state, payload) => {
        state.notifications = [...state.notifications, ...payload.notifications];
        state.pages = payload.pages;
        state.page = payload.pageNumber;
    },
    SET_QNT_NOTIFICATION_PENDENTE: (state, payload) => {
        state.totalPendente = Number(payload)
    },
    UPDATE_NOTIFICATIONS: (state, payload) => {
        state.notifications = payload.notifications;
        localStorage.setItem('notifications', JSON.stringify(payload.notifications));
    },
    SET_LOADING_NOTIFICATIONS: (state, payload) => {
        state.notificationLoading = payload
    },
}

const actions = {
    async notificationsUser({commit}){
        try {
            commit('SET_LOADING_NOTIFICATIONS', true);
            const response = await NotificationService.get(1);
            commit('SET_NOTIFICATIONS', response.data);
            commit('SET_LOADING_NOTIFICATIONS', false);
        } catch (error) {
            commit('SET_LOADING_NOTIFICATIONS', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },

    async moreNotificationsUser({commit},  {pageNumber = 1}){
        try {
            commit('SET_LOADING_NOTIFICATIONS', true);
            const response = await NotificationService.get(pageNumber);
            commit('SET_MORE_NOTIFICATIONS', response.data);
            commit('SET_LOADING_NOTIFICATIONS', false);
        } catch (error) {
            commit('SET_LOADING_NOTIFICATIONS', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
      async notificationQntPendente({commit}){
        try {
            commit('SET_LOADING_NOTIFICATIONS', true);
            const response = await NotificationService.getQntPendente();
            commit('SET_QNT_NOTIFICATION_PENDENTE', response.data);
            commit('SET_LOADING_NOTIFICATIONS', false);
        } catch (error) {
            commit('SET_LOADING_NOTIFICATIONS', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updateNotification({commit, dispatch}, idNotification){
        try {
            const response = await NotificationService.update(idNotification);
            commit('UPDATE_NOTIFICATIONS', response.data);
            dispatch('notificationsUser')
        } catch (error) {
            console.log('Erro no updateNotification');
            console.error(error.response.data.message);
        }
    }
}

const getters = {
    getNotifications: state => state.notifications,
    getNotificationQntPendente: state => state.totalPendente,
    getLoadingNotification: state => state.notificationLoading,
    countUnreadNotifications: (state) => {
        try{
            return state.notifications.filter((item) => item.Users[0].Users_Notifications.visualizado === 'N').length;
        }catch{
            return 0;
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
};